import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilButton } from "../../../utils/utilButton";
import { Icon } from "../icon/Icon";
import { NumberFormat } from "../number-format/NumberFormat";
import { TextLoca } from "../text/TextLoca";
export var ButtonDefault = React.memo(function (_a) {
    var ButtonComponent = _a.component, onClick = _a.onClick, amount = _a.amount, buffedAmount = _a.buffedAmount, amountFormat = _a.amountFormat, icon = _a.icon, disabled = _a.disabled, _b = _a.locaId, locaId = _b === void 0 ? IdLoca.buy : _b;
    var createPriceElement = function (price, className) { return (React.createElement("div", { className: className },
        React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondary, amount: price, format: amountFormat }))); };
    var dividerFilterClass = disabled ? "grey-filter" : "";
    var previousPriceElement = buffedAmount !== undefined && createPriceElement(amount, "previous-price");
    var priceElement = buffedAmount !== undefined
        ? createPriceElement(buffedAmount)
        : createPriceElement(amount);
    return (React.createElement(ButtonComponent, { onClick: function () { return utilButton.onClickWithSound(onClick); }, disabled: disabled },
        React.createElement("div", { className: "flex flex--stacked flex--guts w100 h100" },
            React.createElement("div", null,
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: locaId })),
            React.createElement("div", { className: IdStyles.ButtonDivider + " " + dividerFilterClass }),
            React.createElement("div", { className: "flex flex--guts" },
                icon && React.createElement(Icon, { icon: icon, styleId: IdStyles.IconMedium }),
                previousPriceElement,
                priceElement))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/button-buy/ButtonDefault.tsx
// module id = 154
// module chunks = 3